import { Card, CardContent } from '@material-ui/core';
import React from 'react';


export const ContentContainer = ({
    children
}) => {
    return (
        <Card style={{backgroundColor: '#eeeeee'}} elevation={0}>
            <CardContent style={{backgroundColor: '#eeeeee'}}>
                {children}
            </CardContent>
        </Card>
    );
};